import { parseSchedule } from '@/store/utils'
import {
  getResStatus,
  RES_STATUS,
  RES_SCHEDULE_STATUS,
} from '@/helpers/ResHelper'
import _ from 'lodash'

export const getSysBarHeight = (state) => {
  return state.sysInfo.statusBarHeight + state.sysInfo.titleBarHeight
}

export const fams = (state) => {
  return [state.user, ...state.user.famUsers]
}

export const getAdultAdded = (state) => {
  return state.user.famUsers.filter((u) => {
    return u.userType === 0 && u.id !== state.user.id
  })
}
export const getChildrenAdded = (state) => {
  return state.user.famUsers.filter((u) => {
    return u.userType === 2
  })
}
export const getLatestRes = (state) => {
  if (state.user.reses.length > 0) {
    let res = _.sortBy(state.user.reses, (r) => {
      return parseInt(r.scheduleId.split('-')[0])
    })[0]
    res.schedule = parseSchedule(res.scheduleId)
    return res
  } else return null
}

export const getLatestValidRes = (state) => {
  if (state.user.reses.length > 0) {
    let valid = []
    let reses = state.user.reses

    for (let res of reses) {
      if (
        res.resStatus === RES_STATUS.CREATED ||
        res.resStatus === RES_STATUS.RESCHEDULED
      ) {
        valid.push(res)
      }
    }
    if (valid.length < 1) return null
    let validRes = _.sortBy(valid, (r) => {
      return -parseInt(r.scheduleId.split('-')[0])
    })[0]
    validRes.schedule = parseSchedule(validRes.scheduleId)
    return validRes
  } else return null
}

export const getReses = (state) => {
  if (state.user.reses && state.user.reses.length > 0) {
    // let activeReses = []
    // let inactiveReses = []
    //
    // state.user.reses.forEach((res) => {
    //   console.log(Date.parse(res.updateTime))
    //   if (res.resStatus === 1 || res.resStatus === 2 || res.resStatus === 3) {
    //     inactiveReses.push(res)
    //   } else {
    //     activeReses.push(res)
    //   }
    // })
    //
    // let activeResesSorted = _.sortBy(activeReses, (r) => {
    //   return parseInt(r.scheduleId.split('-')[0])
    // })
    // let inactiveResesSorted = _.sortBy(inactiveReses, (r) => {
    //   return parseInt(r.scheduleId.split('-')[0])
    // })
    //
    // let reses = []
    //
    // activeResesSorted.forEach((res) => {
    //   res.schedule = parseSchedule(res.scheduleId)
    //   reses.push(res)
    // })
    // inactiveResesSorted.forEach((res) => {
    //   res.schedule = parseSchedule(res.scheduleId)
    //   reses.push(res)
    // })
    let valid = []
    let invalid = []
    let reses = state.user.reses

    // reses.forEach((res) => {
    //   res.schedule = parseSchedule(res.scheduleId)
    //   console.log(new Date(res.updateTime))
    // })

    for (let res of reses) {
      //res.resStatus
      res.schedule = parseSchedule(res.scheduleId)
      res.status = getResStatus(
        res.schedule.from,
        res.schedule.to,
        res.resStatus
      )
      if (
        res.resStatus === RES_STATUS.CREATED ||
        res.resStatus === RES_STATUS.RESCHEDULED
      ) {
        valid.push(res)
      } else {
        invalid.push(res)
      }
    }

    let validSorted = _.sortBy(valid, (res) => {
      //res.schedule = parseSchedule(res.scheduleId)
      //return -Date.parse(res.updateTime)
      return -parseInt(res.scheduleId.split('-')[0])
    })
    let invalidSorted = _.sortBy(invalid, (res) => {
      //res.schedule = parseSchedule(res.scheduleId)
      //return -Date.parse(res.updateTime)
      return -parseInt(res.scheduleId.split('-')[0])
    })

    return [...validSorted, ...invalidSorted]
  } else return null
}
